import Vue from "vue";
import VueRouter from "vue-router";
import { authGuard } from "../auth/authGuard";

Vue.use(VueRouter);

const routes = [
  {
    path: "/survey/:id",
    name: "survey",
    meta: {
      title: "Survey"
    },
    component: () =>
      import(
        /* webpackChunkName: "survey" */ "../views/survey/SurveyDetail.vue"
      )
  },
  {
    path: "/preview/:id",
    name: "preview",
    meta: {
      title: "Survey Preview"
    },
    component: () =>
      import(
        /* webpackChunkName: "survey" */ "../views/survey/SurveyPreview.vue"
      )
  },
  {
    path: "/resource/:id",
    name: "resource",
    meta: {
      title: "Resource"
    },
    component: () =>
      import(
        /* webpackChunkName: "resource" */ "../views/resource/ViewResource.vue"
      )
  },
  {
    path: "/register/:id",
    name: "register",
    meta: {
      title: "Register",
      isRegistration: true
    },
    component: () =>
      import(
        /* webpackChunkName: "register" */ "../views/register/Register.vue"
      )
  },
  {
    path: "/surveycomplete",
    name: "survey-complete",
    meta: {
      title: "Survey Already Complete"
    },
    component: () =>
      import(
        /* webpackChunkName: "survey" */ "../views/survey/SurveyAlreadyComplete.vue"
      )
  },
  {
    path: "/surveyinvalid",
    name: "survey-invalid",
    meta: {
      title: "Survey Invalid"
    },
    component: () =>
      import(
        /* webpackChunkName: "survey" */ "../views/survey/SurveyInvalid.vue"
      )
  },
  {
    path: "/resourceunavailable",
    name: "resource-unavailable",
    meta: {
      title: "Resource Unavailable"
    },
    component: () =>
      import(
        /* webpackChunkName: "resource" */ "../views/resource/ResourceUnavailable.vue"
      )
  },
  {
    path: "/error",
    name: "error",
    meta: {
      title: "Error"
    },
    component: () =>
      import(/* webpackChunkName: "error" */ "../views/Error.vue")
  },
  {
    path: "*",
    meta: {
      title: "Invalid Link"
    },
    component: () =>
      import(
        /* webpackChunkName: "survey" */ "../views/survey/SurveyInvalid.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta) {
    document.title = to.meta.title + " | CoreCounts";
  }
  authGuard(to, from, next);
  //next();
});

export default router;
